import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { chains, SUPPORTED_NETWORKS, } from "@gearbox-protocol/sdk/onchain";
import { useCallback, useMemo } from "react";
import { NetworkLogo } from "../icons";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from "./Select";
const ALL_NETWORKS = "__ALL__";
export const NetworkSelect = props => {
    const { allowAll = false, value, onChange, className, includeNetworks = SUPPORTED_NETWORKS, excludeNetworks, } = props;
    const options = useMemo(() => {
        let result = includeNetworks.filter(n => !excludeNetworks?.includes(n));
        if (allowAll) {
            result = [ALL_NETWORKS, ...result];
        }
        return result;
    }, [includeNetworks, excludeNetworks, allowAll]);
    const handleChange = useCallback((v) => {
        if (allowAll) {
            onChange((v === ALL_NETWORKS ? undefined : v));
        }
        else {
            onChange(v);
        }
    }, [allowAll, onChange]);
    return (_jsxs(Select, { value: allowAll ? (value ?? ALL_NETWORKS) : value, onValueChange: handleChange, children: [_jsx(SelectTrigger, { className: className, children: _jsx(SelectValue, {}) }), _jsx(SelectContent, { children: options.map(n => (_jsxs(SelectItem, { value: n, children: [n !== ALL_NETWORKS && (_jsx(NetworkLogo, { chainId: chains[n].id, className: "mr-2" })), n === ALL_NETWORKS ? "All Networks" : n] }, n))) })] }));
};
export default NetworkSelect;
